import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import KeyIcon from "@mui/icons-material/VpnKey";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import ButtonBase from "@mui/material/ButtonBase";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useGetIdentity } from "@refinedev/core";
import { HamburgerMenu, RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";
import React, { useContext, useState } from "react";
import { ColorModeContext } from "../../contexts/color-mode/context";
import { ApiKeysDialog } from "../../pages/api-keys/list";
import { ServiceHealthLight } from "../ServiceHealthLight";

type IUser = {
  id: number;
  name: string;
  avatar: string;
};

export const Header: React.FC<RefineThemedLayoutV2HeaderProps> = ({
  sticky = true,
}) => {
  const { mode } = useContext(ColorModeContext);

  const { data: user } = useGetIdentity<IUser>();

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [apiKeysOpen, setApiKeysOpen] = useState(false);

  const menuOpen = Boolean(menuAnchor);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleCloseMenu = () => setMenuAnchor(null);
  const handleOpenApiKeys = () => {
    handleCloseMenu();
    setApiKeysOpen(true);
  };

  const hasIdentity = Boolean(user?.avatar || user?.name);

  return (
    <AppBar position={sticky ? "sticky" : "relative"}>
      <Toolbar>
        <Stack
          direction="row"
          width="100%"
          justifyContent="flex-end"
          alignItems="center"
        >
          <HamburgerMenu />
          <Stack
            direction="row"
            width="100%"
            justifyContent="flex-end"
            alignItems="center"
          >
            <ServiceHealthLight />
            {hasIdentity && (
              <>
                <ButtonBase
                  onClick={handleOpenMenu}
                  aria-label="Open user menu"
                  aria-haspopup="menu"
                  aria-expanded={menuOpen ? "true" : undefined}
                  sx={{
                    borderRadius: 999,
                    px: 1,
                    py: 0.5,
                    "&:hover": { bgcolor: "action.hover" },
                  }}
                >
                  <Stack
                    direction="row"
                    gap="16px"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {user?.name && (
                      <Typography
                        sx={{
                          display: {
                            xs: "none",
                            sm: "inline-block",
                          },
                        }}
                        variant="subtitle2"
                      >
                        {user.name}
                      </Typography>
                    )}
                    <Avatar src={user?.avatar} alt={user?.name} />
                  </Stack>
                </ButtonBase>
                <Menu
                  anchorEl={menuAnchor}
                  open={menuOpen}
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem onClick={handleOpenApiKeys}>
                    <ListItemIcon>
                      <KeyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>API Keys</ListItemText>
                  </MenuItem>
                </Menu>
              </>
            )}
          </Stack>
        </Stack>
      </Toolbar>
      <ApiKeysDialog
        open={apiKeysOpen}
        onClose={() => setApiKeysOpen(false)}
      />
    </AppBar>
  );
};
